export enum LoadingTypes {
  START_INITIATE = 'START_INITIATE',
  INITIATE = 'INITIATE',
  LOADING_START = 'LOADING_START',
  LOADING_FINISHED = 'LOADING_FINISHED',
}
